"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const defaultState = { src: undefined, status: 'loading' };
function useImage(url, crossOrigin) {
    const [image, setImage] = react_1.useState(defaultState);
    react_1.useEffect(() => {
        if (!url)
            return;
        const img = document.createElement('img');
        const onLoad = () => setImage({ src: img.src, status: 'success' });
        const onError = () => setImage({ src: undefined, status: 'failed' });
        img.addEventListener('load', onLoad);
        img.addEventListener('error', onError);
        if (crossOrigin)
            img.crossOrigin = crossOrigin;
        img.src = url;
        return () => {
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onError);
            setImage(defaultState);
        };
    }, [url, crossOrigin]);
    return Object.assign({}, image);
}
exports.default = useImage;
